import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { If, Then, Else} from 'react-if';
import { useQuery, useMutation } from '@apollo/client';

import 'moment/locale/es';

const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');



// Models
import AcreditacionProfile from '../models/AcreditacionProfile';
import {LIST_PROMOTION_AND_DISCOUNT_CUPONS} from '../models/PromotionAndDiscountCupons';

//Components
import { TableStyled } from '../components/TableStyled';
import SubTitulo from '../components/Subtitulo';
import FormErrors, { trowError } from '../components/FormErrors';


import Loading from '../components/Loading';

// Assets
import bgFrame from '../assets/cupons/frame.jpg';

const StyledPage = styled.main`

  .listCupons{
          display: flex;
          flex-direction: column;
          align-items: center; 
          list-style: none;
          padding: 20px;
          gap: 20px;

          li{
               padding: 15px;
               width: 100%;
               max-width: 555px;

               height: 275px;
               aspect-ratio: 600 / 275;
               gap: 10px;

               background:#fff url(${bgFrame}) no-repeat 50% 100%;  
               border:solid 2px  #282e60;     
               display: grid;
               grid-template-columns: 120px auto;
               grid-template-rows: 55px auto 50px;

               grid-template-areas: "image title" "image text" "none vigencia";

               @media (max-width: 450px) {
                    grid-template-areas: "image" "title" "text" "vigencia";
                    grid-template-columns: auto;
                    grid-template-rows:auto;
                    height: auto;
                    aspect-ratio: auto;                    
               }

               h2{
                    color:var(--color-primary);
                    font-size: 30px;
                    font-weight: 500;
                    grid-template-columns: title;
                    text-align: center;
               }
               .image{
                    grid-area:image;
                    align-self: center;    
                    text-align:center;                 
               }
               .alt{
                    grid-area:text;
                    text-align: center;
                }
               .vigencia{
                    grid-area:vigencia;
                    color:var(--color-rojo);
                    text-align: center;
               }

               p{
                    color:var(--color-primary);
                    
               }
               img{max-width:100%}
          }          
     }

`


const Contenido=styled.div`
  .txt-subtitle{
      color:var(--color-azul);
      font-size:25px; 
      font-weight:bold;
  }
  .txt-paragraph{
      color:#a6a6a6; font-size:15px;
      line-height: 30px;
  }
  .txt-content{
    text-align: center;
    h2{
        padding-top: 10px;
        color: #000;
    }
    p{
        color:#000;
        button{
            padding: 10px 25px;
            font-weight: bold;
        }
    }
  }
`;




export default  () => {
    let UserInfo=AcreditacionProfile.getProfile();

    const { loading, error, data } = useQuery(LIST_PROMOTION_AND_DISCOUNT_CUPONS,{
        variables:{
            'first':50,
            'page':0,
            'profile_uuid':UserInfo.uuid,  
            'type':'MATCHDAY_PROMO'
        },
        context:{
               //clientName:'SITE'
        }
    });

    if(loading)
        return <Loading />
 
    return (
        <StyledPage>
            <SubTitulo>
                <h2></h2>
            </SubTitulo>
            {error?<div className="error-message"><FormErrors errors={error} /></div>:null}

            <Contenido>
                <TableStyled className="col-12">
                    <div className="tit-table">PROMO DÍA DE PARTIDO</div>

                    <ol className='listCupons'>
                        {data?.listPromotionAndDiscountCupons?.edge?.map( item => (
                        <li>
                            <div className='image'><img src={item.image_url} /></div>
                            <h2>{item.title}</h2>
                            <p className='alt'>{item.alt}</p>
                            <p className='vigencia'>{item.valid_to}</p>
                        </li>
                        ))}
                    </ol>

                </TableStyled>
            </Contenido>
        </StyledPage>
    )
}

